/* eslint-disable */
import * as Types from './types';

import { ImageFragmentDoc } from './Image';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type CollectionQueryVariables = Types.Exact<{
  handle: Types.Scalars['String'];
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type CollectionQuery = { __typename?: 'Query', collection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', keyHandle?: string | null, title?: string | null, merchandisedTitle?: string | null, description?: string | null, subtitle?: string | null, backgroundColor?: string | null, backgroundColorOnMobile?: boolean | null, textTheme?: string | null, franchiseBlockTitle?: string | null, franchiseBlockDescription?: string | null, franchiseFeaturesTitle?: string | null, franchiseBlockTheme?: string | null, sys: { __typename?: 'Sys', id: string }, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, desktopImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, franchiseBlockIconsCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename: 'Asset', title?: string | null, width?: number | null, height?: number | null, url?: string | null } | null> } | null } | null> } | null };

export declare const collection: import("graphql").DocumentNode;

export const CollectionDocument = /*#__PURE__*/ `
    query collection($handle: String!, $locale: String = "en-US", $preview: Boolean = false) {
  collection: collectionCollection(
    limit: 1
    locale: $locale
    where: {handle: $handle, sys: {id_exists: true}}
    preview: $preview
  ) {
    items {
      sys {
        id
      }
      keyHandle
      title
      merchandisedTitle
      description
      subtitle
      image {
        ...ImageFragment
      }
      desktopImage {
        ...ImageFragment
      }
      backgroundColor
      backgroundColorOnMobile
      textTheme
      franchiseBlockTitle
      franchiseBlockDescription
      franchiseFeaturesTitle
      franchiseBlockTheme
      franchiseBlockIconsCollection {
        items {
          __typename
          ... on Asset {
            title
            width
            height
            url
          }
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const useCollectionQuery = <
      TData = CollectionQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: CollectionQueryVariables,
      options?: UseQueryOptions<CollectionQuery, TError, TData>
    ) =>
    useQuery<CollectionQuery, TError, TData>(
      ['collection', variables],
      fetcher<CollectionQuery, CollectionQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CollectionDocument, variables, options),
      options
    );

useCollectionQuery.getKey = (variables: CollectionQueryVariables) => ['collection', variables];
;

useCollectionQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: CollectionQueryVariables, options?: RequestInit['headers']) => fetcher<CollectionQuery, CollectionQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CollectionDocument, variables, options);